export var pt = {
  DOES_NOT_CONTAIN: 'Não contém',
  CONTAINS: 'Contém',
  RANGE: 'Rango de',
  EQUALS: 'Igual',
  ENDS_WITH: 'Termina com',
  STARTS_WITH: 'Começa com',
  APPLY: 'Aplicar',
  NUMERIC: 'Numérico',
  TO: 'a'
};